import React, { useEffect } from "react";
import {
  agencyDashboard,
  agencyProfile,
  activeLinkProfile,
} from "../common/allLinks";
import CommonSideNavbar from "../common/CommonSideNavbar";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ProfileDetails from "../common/ProfileDetails";
import ProfileSettingsDisplay from "../common/ProfileSettingsDisplay";
import ButtonCommonComponent from "../common/ButtonCommonComponent";

export default function AgencyProfile() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOnSelect = (val) => {
    // agencyProfileTabIndex
    localStorage.setItem("agencyProfileTabIndex", val);
  };

  useEffect(() => {
    localStorage.removeItem("activeAgencyDashboardTabIndex");
    return () => {
      localStorage.removeItem("agencyProfileTabIndex");
    };
  }, []);

  const onClickChange = () => {
    console.log("change username and password");
  };

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={agencyDashboard}
        profileLink={agencyProfile}
        activeLink={activeLinkProfile}
      />
      <div className="client-profile-main-div sidenavbar-active-menu-page">
        <div className="mt-title-block">
          <h1 className="font-48-NunitoSans-600">Profile</h1>
        </div>
        <div className="mt-platform-tabs pt-25">
          <Tabs
            defaultIndex={parseInt(
              localStorage.getItem("agencyProfileTabIndex")
            )}
            onSelect={handleOnSelect}
          >
            <TabList>
              <Tab>Details</Tab>
              <Tab>Settings</Tab>
            </TabList>
            <TabPanel>
              <ProfileDetails isSkillListPresent={true} />
            </TabPanel>
            <TabPanel>
              <div className="pl-35 pt-25">
                <ProfileSettingsDisplay />
                <ButtonCommonComponent
                  extraClassName="login-btn--modal-btn-border mr-30"
                  text="Change"
                  onClick={onClickChange}
                />
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
